//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appButtonFocusRemover]',
    standalone: false
})
export class ButtonFocusRemoverDirective {
  constructor(private elRef: ElementRef) {}

  @HostListener('click') onClick() {
    this.elRef.nativeElement.blur();
  }
}